$(function(){//ページ読み込み後に動かすjQuery
  
  // ページ内リンクをスクロールに 
  $('a[href^="#"]:not([href^="#recover"])').click(function(){
    const headerH = $('.l-header').outerHeight();
    const href= $(this).attr("href");
    const target = $(href == "#" || href == "" ? 'html' : href);
    const position = target.offset().top - headerH;//固定ヘッダーの分だけずらす
    $("html, body").animate({scrollTop:position}, 800, "swing");
    return false;
  });

  // アコーディオン汎用
  function accToggle(trigger,target,closeAll = false) {
    // triggerには要素
    // targetにはクラス名を入れる
    // closeAll trueにすると、他の同様のアコーディオンを閉じた上で開く
    if(trigger.siblings(target).attr('aria-hidden') == 'false') {
      trigger.siblings(target).attr('aria-hidden','true');
    } else {
      if(closeAll) {
        $(target+'[aria-hidden=false]').attr('aria-hidden','true');
      }
      trigger.siblings(target).attr('aria-hidden','false');
    }
  }

  // ハンバーガー開閉
  $('.l-header-hamburger__btn').click(function(){
    let trigger = $(this);
    let target = '.l-header-hamburger-wrapper';
    $(this).toggleClass('open');
    accToggle(trigger,target);
  });
  
  // ハンバーガー内のアコーディオン開閉
  $('.l-header-hamburger-nav-acc__trigger').click(function(){
    let trigger = $(this);
    let target = '.l-header-hamburger-nav-acc-wrapper';
    $(this).toggleClass('open');
    accToggle(trigger,target);
  });
  
  // フッターメニュー内のアコーディオン開閉
  $('.l-footer-main-nav-acc__trigger').click(function(){
    let trigger = $(this);
    let target = '.l-footer-main-nav-acc-wrapper';
    $(this).toggleClass('open');
    accToggle(trigger,target);
  });
  
  // 商品ページのアコーディオン開閉
  $('.c-product-single-sub-acc__trigger').click(function(){
    let trigger = $(this);
    let target = '.c-product-single-sub-acc-wrapper';
    $(this).toggleClass('open');
    accToggle(trigger,target);
  });
  
  // ページトップに戻るボタン
  const pageTopBtnPC = () => {
    let showFlag = false;
    const topBtn = $('.c-footer-fix-pc__top');    
    topBtn.css('bottom', '-100px');
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        if (showFlag == false) {
          showFlag = true;
          topBtn.stop().animate({'bottom' : '0'}, 200); 
        }
      } else {
        if (showFlag) {
          showFlag = false;
          topBtn.stop().animate({'bottom' : '-100px'}, 200); 
        }
      }
    });
  }
  pageTopBtnPC();

  // swiper(スライダー)
  // トップページスライダー
  const indexMvSlider = new Swiper('.p-index-mv', {//swiperを適用するclassを指定
    //以下設定
    speed: 400,
    loop: true,
    autoplay: {
      delay: 4000
    },
    pagination: {
      el: '.p-index-mv-pagination',
      type: 'bullets',
      clickable: true
    }
  });
  // 商品ページサムネイル画像
  const productSliderThumb = new Swiper('.js-product-single-main-slider-thumbnail', {//swiperを適用するclassを指定
    //以下設定
    slidesPerView: 3.5,
    spaceBetween: 10,
    slideToClickedSlide: true,
    watchSlidesProgress: true,
    breakpoints: {
      1024: {
        slidesPerView: 5,
      },
      1097: {
        slidesPerView: 5,
        direction: 'vertical',
        spaceBetween: 15,
      }
    }
  });
  productSliderThumb.on('tap', function () { //サムネイルがタップされたら、
    var current = productSliderMain.activeIndex; //選ばれたコンテンツの番号をとってきて、
    productSliderThumb.slideTo(current - 4, 500, true); //その番号の4つ前のタブまで500ミリ秒かけてスライドする
  });
  // 商品ページメイン画像
  const productSliderMain = new Swiper('.js-product-single-main-slider', {//swiperを適用するclassを指定
    //以下設定
    slidesPerView: 1,
    loop: true,
    speed: 500,
    navigation: {
      nextEl: ".c-product-single-main-slider__next",
      prevEl: ".c-product-single-main-slider__prev",
    },
    thumbs: {
      swiper: productSliderThumb,
    }
  });
  //productSliderMain.controller.control = productSliderThumb;
  //productSliderThumb.controller.control = productSliderMain;
  
  // 関連商品スライダー
  // スマホのときだけスライダーにする
  const swiperSlides = document.getElementsByClassName("c-product-list-slider");
  const breakPoint = 1023; // ブレークポイントを設定
  let swiper;
  let swiperBool;

  window.addEventListener(
    "load",
    () => {
      if (breakPoint < window.innerWidth) {
        swiperBool = false;
      } else {
        createSwiper();
        swiperBool = true;
      }
    },
    false
  );

  window.addEventListener(
    "resize",
    () => {
      if (breakPoint < window.innerWidth && swiperBool) {
        swiper.destroy(false, true);
        swiperBool = false;
      } else if (breakPoint >= window.innerWidth && !swiperBool) {
        createSwiper();
        swiperBool = true;
      }
    },
    false
  );

  const createSwiper = () => {
    swiper = new Swiper(".c-product-list-slider", {
      slidesPerView: 1.1,
      spaceBetween: 20,
      breakpoints: {
        500: {
          slidesPerView: 1.4,
        }
      }
    });
  };  
  
  ///////
  // 商品ページラジオボタン操作
  ///////
  $('label.c-product-single-main-info-variant-group-inputs__item').click(function() {
    if(!$(this).hasClass('active')) {
      // activeクラスの付替え
      $('label.c-product-single-main-info-variant-group-inputs__item.active').removeClass('active');
      $(this).addClass('active');
      
      // 選択しているカラー名を変更
      const id = $(this).attr('for');
      const value = $('input#'+id).attr('value');
      $('.c-product-single-main-info-variant-group__selected').text(value);
    }
  })
  
  /**
   * トップページ product
   */
  if(navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)){ // モバイルのとき
    $('.p-index-product-img').click(function() {
      if($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).addClass('deactive');
      } else {
        $(this).removeClass('deactive');
        $(this).addClass('active');
      }
    })
  } else { // PCのとき
    $('.p-index-product-img').hover(
      function() {
        $(this).removeClass('deactive');
        $(this).addClass('active');
      },
      function() {
        $(this).removeClass('active');
        $(this).addClass('deactive');
      }
    )
  }
  
  /**
   * 商品一覧ページ絞り込み
   */
  let headTxtObj = {
    'all': '気の利いたアイディアと遊び心溢れるユニークなデザインが<br>室内空間に変化と彩りを与えます。',
    'visible': '隠れた部分に見えない便利さを宿したシリーズ。<br>空間を整えることによって創り上げられる<span class="visible">『秩序』</span>という美しさはFURNi MANiAが考える<span class="visible">見せ方</span>の美学です。',
    'art': '一癖あるデザインが斬新なシリーズ。<br>インパクトのあるアイテムで空間に<span class="art">アクセント</span>と<span class="art">遊び心</span>を。'
  }
  $('.c-product-search__btn').click(function() {
    let tag = $(this).data('tag');
    if(tag == 'all') {
      $('.c-product-list-item').show();
    } else {
      $('.c-product-list-item[data-tag!='+tag+']').hide();
      $('.c-product-list-item[data-tag='+tag+']').show();
    }
    if(!$(this).hasClass('active')) {
      $('.c-product-search__btn').removeClass('active');
      $(this).addClass('active');
    }
    $('.c-product-archive-head__txt').html(headTxtObj[tag]);
  })

  // 商品一覧ページでパラメータ渡された場合、それを初期表示する
  if(window.location.href.indexOf('collections/all') != -1) {
    let url = new URL(window.location.href);
    let params = url.searchParams;
    let type = params.get('type');
    let typeArr = [
      'visible',
      'art'
    ];
    if(typeArr.includes(type)) {
      $('.c-product-list-item[data-tag!='+type+']').hide();
      $('.c-product-list-item[data-tag='+type+']').show();
      $('.c-product-search__btn').removeClass('active');
      $('.c-product-search__btn[data-tag='+type+']').addClass('active');
      $('.c-product-archive-head__txt').html(headTxtObj[type]);
    }
  }
  
});


/**
 * 商品ページ表示データ変更
 */
$('.c-product-single-data-select__btn').click(function() {
  let tag = $(this).data('tag');
    $('.c-product-single-data-body[data-tag!='+tag+']').attr('aria-hidden','true');
    $('.c-product-single-data-body[data-tag='+tag+']').attr('aria-hidden','false');
  if(!$(this).hasClass('active')) {
    $('.c-product-single-data-select__btn').removeClass('active');
    $(this).addClass('active');
  }
})

//下からふわっと表示
const fadeInUp = () => {
  const targets = document.querySelectorAll('.u-fadeinUp');
  let windowHeight = $(window).height();
  $(window).resize(function() {
    windowHeight = $(window).height();
  });
  Object.values(targets).forEach(target => {
    const targetPos = target.getBoundingClientRect().top;
    $(window).scroll(function () {
      let scrollY = $(this).scrollTop();    
      if(scrollY > targetPos - windowHeight) {
        target.classList.add('u-fadeinUp-active');
      }
    })
  })
}
fadeInUp();

